


import { Card } from "react-bootstrap";
import no_image from "../../../images/No_Image_Available.jpg";
import { setMobileTextColor } from "../../../utility";

const Section = ({
  section,
  handleParentSection,
  disabledFlag,
  handleSectionScroll,
  parentSectionName,
  isMobile = true,
  isDesktop = false,
  isMainSection = false,
  isSubSection = false,
}) => {
  const onImageError = (e) => {
    e.target.src = no_image;
  };

  const getCardDimensions = () => {
    if (isMainSection) {
      return {
        height: isDesktop ? "300px" : "210px",
        className: isDesktop
          ? "main-section-card_desktop"
          : "main-section-card_mobile",
      };
    }

    if (isDesktop) {
      return {
        height: isSubSection ? "180px" : "600px",
        className: isSubSection ? "sub-section-card" : "sections-card",
      };
    }

    if (isMobile) {
      return {
        height: parentSectionName ? "180px" : "240px",
        className: disabledFlag === 0 ? "sections-sub-card" : "sections-card",
      };
    }

    return {
      height: "200px",
      className: disabledFlag === 0 ? "sections-sub-card" : "sections-card",
    };
  };

  const dimensions = getCardDimensions();

  return (
    <div
      ref={(el) => (disabledFlag == 1 ? handleSectionScroll(el) : null)}
      className={`${isMainSection
          ? "col-12"
          : isDesktop
            ? "col-12"
            : parentSectionName
              ? "col-6"
              : "col-12"
        } mt-3 px-2`}
    >
      <Card
        className={`${dimensions.className} rounded-4 shadow-sm position-relative overflow-hidden cursor-pointer`}
        style={{
          height: dimensions.height,
          margin: "0 auto",
          border: "1px solid #e0e0e0",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          if (isDesktop) {
            e.currentTarget.style.transform = "translateY(-5px)";
            e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
          }
        }}
        onMouseLeave={(e) => {
          if (isDesktop) {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
          }
        }}
        onClick={() => (disabledFlag == 1 ? null : handleParentSection(section))}
      >
        {/* Background Image */}
        <Card.Img
          variant="top"
          src={section?.image || no_image}
          className="w-100 h-100 object-fit-cover"
          onError={onImageError}
          style={{
            transition: "transform 0.3s ease",
          }}
        />

        {/* Dark Overlay for better text visibility */}
        {(isMainSection || isSubSection) && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background:
                "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.75))",
              // zIndex: 1,
            }}
          ></div>
        )}

        {/* Text Overlay */}
        <Card.Body
          className={`position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3 text-center`}
          // style={{ zIndex: 2 }}
        >
          {(isMainSection || isSubSection || disabledFlag == 0) && (
            <Card.Title className="m-0">
              <p
                className="head-font text-white mb-2"
                style={{
                  fontSize: isMainSection
                    ? isDesktop
                      ? "1.8rem"
                      : "1.4rem"
                    : isDesktop
                      ? "1.1rem"
                      : "1rem",
                  fontWeight: "700",
                  textShadow:
                    "2px 2px 10px rgba(0,0,0,0.9), 0 0 8px rgba(0,0,0,0.8)",
                }}
              >
                {section?.name}
              </p>

              {isMainSection && section.description && (
                <p
                  className="sub-font text-white mt-2 mb-0"
                  style={{
                    fontSize: isDesktop ? "1.1rem" : "0.9rem",
                    opacity: 0.95,
                    textShadow: "1px 1px 6px rgba(0,0,0,0.9)",
                  }}
                >
                  {section.description}
                </p>
              )}
            </Card.Title>
          )}
        </Card.Body>
      </Card>

      {/* Extra Content Below for Main Sections */}
      {(isMainSection || disabledFlag == 1) && !isSubSection && (
        <div className="text-center mt-2">
          {/* <Card.Title
            className={`head-font ${isMainSection
                ? isDesktop
                  ? "font-size-24"
                  : "font-size-20"
                : isDesktop
                  ? "font-size-18"
                  : "font-size-20"
              }`}
            style={{ color: setMobileTextColor() }}
          >
            {section.name}
          </Card.Title> */}

          {section.description && !isMainSection && (
            <Card.Text
              className={`sub-font ${isDesktop ? "font-size-14" : "font-size-16"}`}
              style={{
                color: setMobileTextColor(),
                opacity: 0.8,
                lineHeight: "1.4",
                maxHeight: isDesktop ? "40px" : "none",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {section.description}
            </Card.Text>
          )}
        </div>
      )}
    </div>
  );
};

export default Section;
